module.exports = __webpack_public_path__ + "static/media/lakoepulet-bontas-azbesztmentesitessel.1f41cc9a.jpg";